<template>
  <div ref="whole_page" class="w-full">

    <div v-if="isFolderContentViewActive || (isResourceContentViewActive && selectedFolder.id)" class="vx-row">
      <div class="vx-col">
        <div class="flex" style="align-items: baseline;">
          <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="categorySelected(selectedCategory)">
            <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
          </div>
          <div v-for="(_folder, index) in selectedFolders" :key="index" class=" flex" style="height: 16px">
            <h6>/</h6>
            <div class="flex mx-3" :class="[{ 'cursor-pointer':(selectedFolder.id != _folder.id || (isResourceContentViewActive && selectedFolder.id)) }, { 'cursor-not-allowed':selectedFolder.id == _folder.id && !(isResourceContentViewActive && selectedFolder.id) }]" @click="goBackToFolder(_folder)">
              <feather-icon icon="FolderIcon" svg-classes="stroke-current h-4 w-4"></feather-icon>
              <h6 class="ml-2">{{ _folder.name }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>

    <select-category
      :isCategoryViewActive="isCategoryViewActive"
      :categories="categories"
      @categorySelected="categorySelected"
      :isStudent="isStudent"
      :isTeacher="isTeacher"
    />

    <select-resource
      :isResourceViewActive="isResourceViewActive"
      :selectedCategory="selectedCategory"
      :allResources="allResources"
      :folders="folders"
      @resourceSelected="resourceSelected"
      @folderSelected="folderSelected"
      @backToSelectCategory="backToSelectCategory"
      @addFolder="addFolder"
      @editFolder="editFolder"
      @deleteFolder="deleteFolder"
      @addResource="addResource"
      @editResource="editResource"
      @deleteResource="deleteResource"
    />
    
    <select-resource-content
      :isResourceContentViewActive="isResourceContentViewActive"
      :selectedCategory="selectedCategory"
      :selectedResource="selectedResource"
      :selectedFolder="selectedFolder"
      @contentSelected="contentSelected"
      @backToSelectCategory="backToSelectCategory"
      @backToSelectResource="backToSelectResource"
      :isStudent="isStudent"
      :selectedFolders="selectedFolders"
    />

    <folder-content
      :isFolderContentViewActive="isFolderContentViewActive"
      :folders="folders"
      :resources="allResources"
      @folderSelected="folderSelected"
      @addFolder="addFolder"
      @editFolder="editFolder"
      @deleteFolder="deleteFolder"
      @addResource="addResource"
      @editResource="editResource"
      @deleteResource="deleteResource"
      @resourceSelected="resourceSelected"
    />

    <vs-popup id="folder-popup" :title="`${folderData.id ? 'Edit' : 'Create'} Folder`" width="400px" :active.sync="folderPopupActive">
      <div class="vx-row mx-auto">
        <div class="vx-col w-full">
          <p>Name</p>
          <vs-input class="w-full" v-model="folderData.name" />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Description</p>
          <vs-input class="w-full" v-model="folderData.description" />
        </div>
      </div>
      
      <div class="vx-row mx-auto mt-4">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            :disabled="!folderData.name && !folderData.description"
            ref="save_btn"
            size="small"
            class="text-white vs-con-loading__container"
            type="filled"
            color="success"
            @click.stop.prevent="saveFolder">
            Save
          </vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            size="small"
            class="vs-con-loading__container"
            type="border"
            color="warning"
            @click.stop.prevent="folderPopupActive = false">
            Cancel
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="resource-popup" title="Create Resource" width="400px" :active.sync="resourcePopupActive">
      <div class="vx-row mx-auto">
        <div class="vx-col w-full">
          <p>Name</p>
          <vs-input class="w-full" v-model="resourceData.name" />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Description</p>
          <vs-input class="w-full" v-model="resourceData.description" />
        </div>
      </div>

      <div v-if="!selectedFolder.id" class="vx-row mx-auto mt-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Term</label>
          <v-select
              ref="termDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Term"
              :options="termList"
              v-model="termDropdown"
              :clearable="true"
          >
            <span slot="no-options" style="color: rgb(202, 202, 202)">No Terms have been made yet.</span>
          </v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Grade</label>
          <v-select
              ref="gradeDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Grade"
              :options="gradeList"
              v-model="gradeDropdown"
              :clearable="true"
          >
              <span slot="no-options" style="color: rgb(202, 202, 202)">No Grades have been made yet.</span>
          </v-select> 
        </div>
      </div>
      
      <div class="vx-row mx-auto mt-4">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            :disabled="!resourceData.name && !resourceData.description"
            ref="save_btn"
            size="small"
            class="text-white vs-con-loading__container"
            type="filled"
            color="success"
            @click.stop.prevent="saveResource">
            Save
          </vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            size="small"
            class="vs-con-loading__container"
            type="border"
            color="warning"
            @click.stop.prevent="resourcePopupActive = false">
            Cancel
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>


<script>
import SelectCategory from "./AdditionalResourceComponents/SelectCategory.vue";
import SelectResource from './AdditionalResourceComponents/SelectResource.vue';
import SelectResourceContent from './AdditionalResourceComponents/SelectResourceContent.vue';
import FolderContent from './AdditionalResourceComponents/FolderContent.vue';
import vSelect from 'vue-select'
export default {
  components: {
    SelectCategory,
    SelectResource,
    SelectResourceContent,
    FolderContent,
    vSelect
  },
  data() {
    return {
      categories: [],
      allResources: [],
      selectedCategory: {},
      selectedResource: {},
      isCategoryViewActive: true,
      isResourceViewActive: false,
      isResourceContentViewActive: false,
      isFolderContentViewActive: false,
      isStudent: false,
      isTeacher: false,
      folderPopupActive: false,
      folderData: {
        id: 0,
        name: "",
        description: "",
        resourceCategoryId: null,
        parentFolderId: null
      },
      resourceData: {
        id: 0,
        name: "",
        description: "",
        moduleGroupId: null,
        courseClassificationId: null,
        resourceCategoryId: null,
        parentFolderId: null,
        additionalResourceFolderId: null
      },
      folders: [],
      selectedFolder: {},
      selectedFolders: [],
      resourcePopupActive: false,
      gradeDropdown: 0,
      gradeList: [],
      termDropdown: 0,
      termList: [],
    };
  },
  methods: {
    getCategories(stopLoading, whenDone) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          self.categories = response.data.map(x => { return { id: x.value, name: x.text } });

          if (whenDone && typeof whenDone == "function")
            whenDone();
        }
      };

      var onFinally = function(response) {
        if (stopLoading) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self, "ResourceCategory/MenuList", onSuccess, onFinally);
    },
    getResources(whenDone) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          self.allResources = response.data.filter(x => x.topicId != 0);
          if (!self.selectedFolder.id) {
            self.isCategoryViewActive = false;
            self.isResourceViewActive = true;
          }

          if (whenDone && typeof whenDone == "function")
            whenDone();
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, `additionalResources/GetAllData?${self.selectedFolder.id ? '' : 'categoryId=' + self.selectedCategory.id}${self.selectedFolder.id ? 'parentFolderId=' + self.selectedFolder.id : ''}`, onSuccess, onFinally);
    },
    categorySelected(category) {
      this.selectedCategory = category;
      this.folders = [];
      this.selectedFolder = {};
      this.isResourceViewActive = false;
      this.isResourceContentViewActive = false;
      this.isFolderContentViewActive = false;
      this.selectedFolders = [];
      this.getResources();
      this.getFolders();
    },
    resourceSelected(resource) {
      this.selectedResource = resource;
      this.isResourceViewActive = false;
      this.isFolderContentViewActive = false;
      this.isResourceContentViewActive = true;
    },
    contentSelected(task, index, standaloneContentDto, selectedData) {
      localStorage.setItem("selectedCategory", selectedData.selectedCategory.id);
      localStorage.setItem("selectedResource", selectedData.selectedTopic.id);

      if (task.video) {
        this.$router.push({
          name: "VideoViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id, ref: "resources"}
        });
      }
      else if (task.document) {
        this.$router.push({
          name: "DocumentViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id, ref: "resources"}
        });
      } else if (task.podcast) {
        this.$router.push({
          name: "PodcastViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            selectedData: selectedData
          },
          query:{"id":task.id, ref: "resources"}
        });
      } else if (task.quiz){
        this.getQuizTask(task.quiz.id, selectedData.selectedTopic.id);
      }
    },
    getQuizTask(taskId, moduleId) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function (response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
        self.$router.push({ name: "QuizTaskViewer", params: {
          taskId: taskId,
          moduleId: moduleId,
          quiz: response.data,
        }});
      };
      var onFinally = function(response) {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self, "Student/GetQuizTask?moduleId=" + moduleId + "&quizTaskId=" + taskId, onSuccess, onFinally);
    },
    backToSelectCategory() {
      this.allResources = [];
      this.isResourceViewActive = false;
      this.isResourceContentViewActive = false;

      this.isCategoryViewActive = true;
    },
    backToSelectResource() {
      this.isCategoryViewActive = false;
      this.isResourceContentViewActive = false;

      this.isResourceViewActive = true;
    },
    initFolderValues() {
      this.folderData.id = 0;
      this.folderData.name = "";
      this.folderData.description = "";
      this.folderData.resourceCategoryId = null;
      this.folderData.parentFolderId = null;
    },
    addFolder() {
      var self = this;
      self.initFolderValues();
      self.folderPopupActive = true;
    },
    editFolder(folder) {
      var self = this;
      self.folderData.id = folder.id;
      self.folderData.name = folder.name;
      self.folderData.description = folder.description;
      self.folderData.resourceCategoryId = folder.resourceCategoryId;
      self.folderData.parentFolderId = folder.parentFolderId;
      self.folderPopupActive = true;
    },
    deleteFolder(folderId) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        self.folderPopupActive = false;
        self.getFolders();
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, "AdditionalResources/DeleteFolder/" + folderId, onSuccess, onFinally);
    },
    saveFolder() {
      var self = this;
      self.showLoadingOnElement('save_btn', 0.3, 'material');

      self.folderData.resourceCategoryId = self.selectedFolder.id ? null : self.selectedCategory.id;
      self.folderData.parentFolderId = self.selectedFolder.id;

      var onSuccess = function(response) {
        self.folderPopupActive = false;
        self.getFolders();
      };

      var onFinally = function(response) {
        if (self.$refs.save_btn) {
          self.$vs.loading.close(self.$refs.save_btn.$el);
        }
      };

      self.$ajaxPost(self, "AdditionalResources/AddEditFolder", self.folderData, onSuccess, onFinally);
    },
    getFolders() {
      var self = this;

      var onSuccess = function(response) {
        self.folders = response.data;
      };

      self.$ajaxGet(self, `AdditionalResources/ListFolders?${self.selectedFolder.id ? '' : 'categoryId=' + self.selectedCategory.id}${self.selectedFolder.id ? 'parentFolderId=' + self.selectedFolder.id : ''}`, onSuccess);
    },
    folderSelected(folder, whenDone) {
      this.selectedFolder = folder;
      this.folders = [];
      this.allResources = [];
      this.getResources(whenDone);
      this.getFolders();
      this.selectedFolders.push(folder);
      this.isResourceContentViewActive = false;
      this.isResourceViewActive = false;
      this.isFolderContentViewActive = true;
    },
    goBackToFolder(folder) {
      var self = this;
      var indexOfFolder = self.$findIndexWithAttr(self.selectedFolders, 'id', folder.id);

      if (indexOfFolder != -1) {
        self.selectedFolders.length = indexOfFolder;
        self.folderSelected(folder);
      }
    },
    initResourceValues() {
      this.resourceData.id = 0;
      this.resourceData.name = "";
      this.resourceData.description = "";
      this.resourceData.moduleGroupId = null;
      this.resourceData.courseClassificationId = null;
      this.resourceData.resourceCategoryId = null;
      this.resourceData.parentFolderId = null;
      this.resourceData.additionalResourceFolderId = null;
      this.gradeDropdown = 0;
      this.termDropdown = 0;
    },
    addResource() {
      var self = this;
      self.initResourceValues();
      self.resourcePopupActive = true;
    },
    editResource(resource) {
      var self = this;
      self.resourceData.id = resource.topicId;
      self.resourceData.name = resource.name;
      self.resourceData.description = resource.description;
      self.resourceData.moduleGroupId = resource.termId;
      self.resourceData.courseClassificationId = resource.gradeId;

      self.termDropdown = self.termList.filter(function(item){
        return item.value == resource.termId;
      })[0];
      self.gradeDropdown = self.gradeList.filter(function(item){
        return item.value == resource.gradeId;
      })[0];

      self.resourcePopupActive = true;
    },
    deleteResource(resourceId) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        self.resourcePopupActive = false;
        self.getResources();
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxDelete(self, "DeleteAdditionalResources/Delete/" + resourceId, onSuccess, onFinally);
    },
    saveResource() {
      var self = this;
      self.showLoadingOnElement('save_btn', 0.3, 'material');

      self.resourceData.resourceCategoryId = self.selectedFolder.id ? null : self.selectedCategory.id;
      self.resourceData.parentFolderId = self.selectedFolder.id;
      self.resourceData.additionalResourceFolderId = self.selectedFolder.id;

      self.resourceData.moduleGroupId = self.termDropdown ?  self.termDropdown.value : null ;
      self.resourceData.courseClassificationId = self.gradeDropdown ?  self.gradeDropdown.value : null;

      var onSuccess = function(response) {
        self.resourcePopupActive = false;
        self.getResources();
      };

      var onFinally = function(response) {
        if (self.$refs.save_btn) {
          self.$vs.loading.close(self.$refs.save_btn.$el);
        }
      };

      self.$ajaxPost(self, "additionalResources/AddEdit", self.resourceData, onSuccess, onFinally);
    },
    getTermData(){
      var self = this;

      var onSuccess = response=>{
          self.termList = response.data.map(x=>{
              return{label: x.name, value: x.id}
          });
      };
      self.$ajaxGet(self, "ModuleGroup/ListModuleGroups", onSuccess);
    },
    getGradeData(){
      var self = this;

      var onSuccess = response=>{
          self.gradeList = response.data.map(x=>{
              return{label: x.name, value: x.id}
          });
      };
      self.$ajaxGet(self, "CourseClassification/ListClassifications", onSuccess);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  mounted() {
    var self = this;
    self.$setColors();

    self.$store.dispatch("updateTheme", "dark");

    self.isStudent = self.$acl.check("Student");
    self.isTeacher = self.$acl.check("Teacher");

    if (self.$acl.not.check('Student')) {
      self.getTermData();
      self.getGradeData();
    }

    var stored_selectedCategory = localStorage.getItem("selectedCategory");
    var stored_selectedResource = localStorage.getItem("selectedResource");
    var stored_selectedFolders = JSON.parse(localStorage.getItem("selectedFolders"));

    if (stored_selectedCategory || stored_selectedResource || stored_selectedFolders) {
      self.getCategories(false, function() {
        if (stored_selectedFolders && stored_selectedFolders.length > 0) {
          self.showLoadingOnElement('whole_page', 1, 'material');
          self.selectedCategory = self.categories.filter(x => x.id == stored_selectedCategory)[0];
          self.isCategoryViewActive = false;

          for (let index = 0; index < stored_selectedFolders.length; index++) {
            const folder = stored_selectedFolders[index];
            if (index == (stored_selectedFolders.length - 1)) {
              self.folderSelected(folder, function() {
                self.getResources(function() {
                  self.resourceSelected(self.allResources.filter(x => x.topicId == stored_selectedResource)[0]);
                  self.$vs.loading.close(self.$refs.whole_page.$el);
                });
              });
            } else {
              self.folderSelected(folder);
            }
          }

          localStorage.removeItem("selectedCategory");
          localStorage.removeItem("selectedResource");
          localStorage.removeItem("selectedFolders");

        } else if (stored_selectedCategory && stored_selectedResource) {
          self.selectedCategory = self.categories.filter(x => x.id == stored_selectedCategory)[0];
          self.getFolders();
          self.getResources(function() {
            self.resourceSelected(self.allResources.filter(x => x.topicId == stored_selectedResource)[0]);
            localStorage.removeItem("selectedCategory");
            localStorage.removeItem("selectedResource");
          });
        }
      });
    } else {
      self.getCategories(true);
    }
  }
};
</script>

<style lang="scss">
  
</style>
